import { useMutation } from '@tanstack/react-query';

import { Membership } from 'src/features/membership/types';
import { ConvertActiveStayToMembershipFormSchemaValues } from 'src/features/stay/utils/formSchema';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/memberships/membership/convert-active-stay/';

interface DTO extends ConvertActiveStayToMembershipFormSchemaValues {
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<Membership> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useConvertActiveStay };
